exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".open-content{flex:1;display:flex;flex-flow:column;font-size:14px;line-height:32px;overflow:auto;padding:10px}.project-item{padding:5px;margin:3px;color:#666}.project-item i{color:#82b640}.project-item:hover{outline:2px solid #75b325;background:#fbfbfb}.project-item.selected{outline:3px solid #75b325;background:#fbfbfb}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e217b9c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shell/components/OpenDialog.vue
// module id = 264
// module chunks = 0